import React, { useState, useEffect, useRef } from "react";
import {
  Container, Row, Col, Card, CardBody, Nav, NavItem, NavLink, TabContent, TabPane, FormGroup, Label, Input, Button,
  CardHeader
} from "reactstrap";
import Select from "react-select";
import classnames from "classnames";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { useAuthUserDetails } from "components/Common/getAuthUserDetails";
import { useDispatch, useSelector } from "react-redux";
import { applyLeaveOrPermissionOrOnduty, checkLeaveExists, fetchAttendanceEmployeeList, fetchAttendanceLeaveType, fetchEmployeeDropdownAutoList, fetchLeaveBalance, fetchWeekOfDates, resetAll,checkEmployeeLeaveType } from "store/actions";
import { useFormik } from "formik";
import CustomSelect from "components/Common/custom-select";
import Breadcrumbs from "components/Common/Breadcrumb";
import CustomDatePicker from "common/CustomDatePicker";
import CustomTimePicker from "common/CustomTimePicker";
import CustomDateTimePicker from "common/CustomDateTimePicker";
import dayjs from "dayjs";
import { sessionOptions } from "common/data/constants";
import TableContainer from "components/Common/TableContainer";
import Loader from "common/pageLoader";

const timeFormat = "hh:mm A"; // 12 hour format

const LeaveApply = ({ selectedDay, onSuccess }) => {
  const [activeTab, setActiveTab] = useState("Leave");
  const [authDetails, setAuthDetails] = useState(null);

  const dispatch = useDispatch()
  const leaveFormikRef = useRef(null);
  const permissionFormikRef = useRef(null);
  const odFormikRef = useRef(null);
  const {
      employees,
      leaveTypes,
      leaveBalance,
      weekOfDates,
      employee_leavetypes,
      loading,
      success,
      error,
      } = useSelector((state) => ({
      employees: state.AttendanceLeaveManagReducer?.employees ?? [],
      leaveTypes: state.AttendanceLeaveManagReducer?.leaveTypes ?? [],
      leaveBalance: state.AttendanceLeaveManagReducer?.leaveBalance ?? [],
      weekOfDates: state.AttendanceLeaveManagReducer?.weekOfDates ?? [],
      employee_leavetypes: state.AttendanceLeaveManagReducer?.employee_leavetypes ?? [],
      loading: state.AttendanceLeaveManagReducer?.loading ,
      error: state.AttendanceLeaveManagReducer?.error,
      success: state.AttendanceLeaveManagReducer?.success ,
  }));

  const { holidays, weekOffs } = weekOfDates;
  const [localWeekOfDates, setLocalWeekOfDates] = useState({ holidays: [], weekOffs: [] });
  const authUserDetails = useAuthUserDetails();
  const authUser = authUserDetails?.[0];
 
  useEffect(() => {
    if (weekOfDates?.holidays || weekOfDates?.weekOffs) {
      setLocalWeekOfDates({
        holidays: weekOfDates.holidays ?? [],
        weekOffs: weekOfDates.weekOffs ?? []
      });
    } else {
      setLocalWeekOfDates({ holidays: [], weekOffs: [] });
    }
  }, [weekOfDates]);

  const dropdownAutoList =
    employees?.map((item) => ({
      value: item.emp_id,
      label: item.emp_name,
      category: item.category,
      department: item.department,
      availed_bank_hours: item.availed_bank_hours,
      balance_bank_hours: item.balance_bank_hours,
    })) ?? [];

  // const leaveTypeOptions =
  //   leaveTypes?.map((item) => ({
  //     value: item.leavetypeid,
  //     label: item.leavetype,
  //     eligible_leave:item.eligible_leave
  //   })) ?? [];


  useEffect(() => {
      const authUserDetails = useAuthUserDetails();
      setAuthDetails(authUserDetails[0])
      const unitId = authUserDetails[0].unit_id
      const user_id = authUserDetails[0].user_id
      // dispatch(resetAll());
      const formData = new FormData()
      formData.append('emp_id',0)
      formData.append('leave_date','')
      formData.append('unit_id',unitId)
      formData.append('create_by',user_id)
      dispatch(fetchAttendanceEmployeeList(formData))
      dispatch(fetchAttendanceLeaveType(unitId))
  }, [dispatch]);

  // Validation Schema for Leave
  const leaveValidationSchema = Yup.object().shape({
    leaveType: Yup.string().required("Leave Type is required"),
    fromDate: Yup.date().nullable().required("From Date is required"),
    toDate: Yup.date().nullable().required("To Date is required"),
    reason: Yup.string().required("Reason is required"),
    halfDay: Yup.boolean(),
    holidayDate: Yup.date()
        .nullable()
        .when("halfDay", {
          is: true,
          then: Yup.date()
            .nullable()
            .required("Halfday Date is required")
            .typeError("Halfday Date must be a valid date"),
          otherwise: Yup.date().nullable()
        }),
      // Validate session only if halfDay is true
      session: Yup.string().when("halfDay", {
        is: true,
        then: Yup.string().required("Session is required"),
        otherwise: Yup.string().nullable(),
      }),
    noOfDays: Yup.number()
    .required("Number of Days is required"),
    // .test(
    //   "balance-leave",
    //   "You do not have enough balance leave for this leave type",
    //   function (value) {
    //     const { leaveType } = this.parent;

    //     const selectedLeave = leaveTypeOptions.find(
    //       l => String(l.value) === String(leaveType)
    //     );

    //     if (!selectedLeave || selectedLeave.eligible_leave === 0) return true;

    //     const balance = parseFloat(leaveBalance[0]?.balance_leave || 0);

    //     return value <= balance;
    //   }
    // ),
    attachment: Yup.mixed()
    .test(
      "fileSize",
      "File too large, max 2MB",
      (value) => {
        if (!value) return true; // skip if no file
        return value.size <= 2 * 1024 * 1024;
      }
    )
    .test(
      "fileType",
      "Only PDF/JPG/PNG files are allowed",
      (value) => {
        if (!value) return true; // skip if no file
        return ["application/pdf", "image/jpeg", "image/png"].includes(value.type);
      }
    ),
  });

  useEffect(() => {
    if (!authUser?.empid) return;
 
    const formData = new FormData();
    formData.append("emp_id", authUser.empid);
 
    dispatch(checkEmployeeLeaveType(formData));
 
  }, [authUser?.empid, dispatch]);
 
  const employeeLeaveTypeOptions =
    Array.isArray(employee_leavetypes?.data)
      ? employee_leavetypes.data.map(item => ({
        value: item.leavetype_id,
        label: item.leave_type,
        eligible_leave: item.eligible_leave,
      }))
      : [];
 

  // Validation Schema for Permission
  const permissionValidationSchema = Yup.object().shape({
    fromDate: Yup.date()
      .nullable()
      .required("Date is required"),

    fromTime: Yup.string()
      .nullable()
      .required("From Time is required"),

    toTime: Yup.string()
      .nullable()
      .required("To Time is required")
      .test("is-after", "To Time must be after From Time", function (value) {
        const { fromTime } = this.parent;
        if (!fromTime || !value) return true;

        const from = dayjs(fromTime, timeFormat);
        const to = dayjs(value, timeFormat);

        return to.isAfter(from);
      }),

    reason: Yup.string()
      .required("Reason is required")
      .max(250, "Reason must be 250 characters or less"),
  });

  // Validation Schema for On Duty
  const ondutyValidationSchema = Yup.object().shape({
    fromTime: Yup.date()
      .nullable()
      .required("From Time is required"),

    toTime: Yup.date()
      .nullable()
      .required("To Time is required")
      .test("is-after", "To Time must be after From Time", function (value) {
      const { fromTime } = this.parent;
      if (!fromTime || !value) return true;
        return value > fromTime;
    }),

    reason: Yup.string()
      .required("Reason is required")
      .max(250, "Reason must be 250 characters or less"),
  });

  // const leaveTypeOptions = [
  //   { value: "Leave", label: "Casual Leave" },
  //   { value: "Casual Leave", label: "Casual Leave" },
  //   { value: "Sick Leave", label: "Sick Leave" },
  //   { value: "Compensation Off", label: "Compensation Off" },
  // ];

  const formik = useFormik({
    initialValues: {
      employee: authDetails?.empid,       // single emp_id
      category: "",
      department: ""
    },
    // validationSchema: Yup.object({
    //   employee: Yup.string()
    //     .required("Employee is required")
    // }),
    onSubmit: (values) => {
      console.log("Form Values:", values);
      // handle API submit here
    }
  });

  const initialLeaveValues = {
    employee: authDetails?.empid,
    leaveType: "",
    fromDate: "",
    toDate: "",
    reason: "",
    halfDay: false,
    holidayDate: "",
    session: "",
    noOfDays: 0,
    attachment: null,
  };

  useEffect(() => {
    if (success) {
      // Reset all Formik forms
      
    //   leaveFormikRef.current?.resetForm();
    //   permissionFormikRef.current?.resetForm();
    //   odFormikRef.current?.resetForm();
    //   formik.resetForm();
    //   setLocalWeekOfDates({ holidays: [], weekOffs: [] });

    //   dispatch(resetAll());
    //   const formData = new FormData()
    //   formData.append('emp_id',0)
    //   formData.append('leave_date','')
    //   formData.append('unit_id',authDetails?.unit_id)
    //   formData.append('create_by',authDetails?.user_id)
    //   dispatch(fetchAttendanceEmployeeList(formData))
    //   dispatch(fetchAttendanceLeaveType(authDetails?.unit_id))
    //   setActiveTab('Leave')

    onSuccess?.();
    }
  }, [authDetails,success,dispatch]);  

  const updateTotalHours = (fromDateTime, toDateTime) => {
    if (!fromDateTime || !toDateTime) return;

    const start = new Date(fromDateTime);
    const end = new Date(toDateTime);

    // let diff = (end - start) / (1000 * 60 * 60); // in hours

    // // If To Time is earlier than From Time → assume overnight shift (next day)
    // if (diff < 0) {
    //   diff += 24;
    // }

    // formik.setFieldValue("totalHours", diff.toFixed(2));
    let diffMs = end - start;

    // Handle overnight shift
    if (diffMs < 0) {
      diffMs += 24 * 60 * 60 * 1000;
    }

    const totalMinutes = Math.floor(diffMs / (1000 * 60));
    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;

    // Store raw minutes (best for backend)
    formik.setFieldValue("totalMinutes", totalMinutes);
    // Store display value
    formik.setFieldValue("totalHours", `${hours} hour${hours !== 1 ? "s" : ""} ${minutes > 0 ? `${minutes} minute${minutes !== 1 ? "s" : ""}` : ""}`);
  };

  const handleSubmit = async (tabName, values) => {
    const errors = await formik.validateForm();
    if (Object.keys(errors).length > 0) {
      formik.setTouched(
        Object.keys(errors).reduce((acc, key) => ({ ...acc, [key]: true }), {})
      );
      return; // stop submit
    }
    // console.log(`Form submitted from ${tabName} tab:`, values);
    let formData = new FormData();
      // Map values based on tab
    if (tabName === "Leave") {
      formData.append("emp_id", authDetails?.empid);
      formData.append("leave_type", values.leaveType);
      formData.append("from_date", values.fromDate);
      formData.append("to_date", values.toDate);
      formData.append("half_day", values.halfDay ? "1" : "0");
      formData.append("half_day_date", values.holidayDate || "");
      formData.append("leave_as", values.session || 0);
      formData.append("no_of_days", values.noOfDays.toString());
      formData.append("remarks", values.reason);
      formData.append("create_by", authDetails?.user_id || "");
      formData.append("unit_id", authDetails?.unit_id || "");
      if (values.attachment) formData.append("file", values.attachment);
    } else if (tabName === "Permission") {
      formData.append("emp_id", authDetails?.empid);
      formData.append("permission_date", values.fromDate);
      formData.append("from_time", values.fromTime);
      formData.append("to_time", values.toTime);
      formData.append("remarks", values.reason);
      formData.append("create_by", authDetails?.user_id || "");
      formData.append("unit_id", authDetails?.unit_id || "");
    } else if (tabName === "Onduty") {
      // Parse fromTime and toTime to separate date and time
      const fromDateTime = new Date(values.fromTime);
      const toDateTime = new Date(values.toTime);

      const fromDate = fromDateTime.toISOString().split("T")[0]; // YYYY-MM-DD
      const toDate = toDateTime.toISOString().split("T")[0];     // YYYY-MM-DD

      const fromTime = fromDateTime.toLocaleTimeString("en-US", {
        hour: "2-digit",
        minute: "2-digit",
        hour12: true
      }); // "09:00 AM"

      const toTime = toDateTime.toLocaleTimeString("en-US", {
        hour: "2-digit",
        minute: "2-digit",
        hour12: true
      }); 
      formData.append("emp_id", authDetails?.empid);
      formData.append("from_date", fromDate);
      formData.append("to_date", toDate);
      formData.append("from_time", fromTime);
      formData.append("to_time", toTime);
      formData.append("remarks", values.reason);
      formData.append("create_by", authDetails?.user_id || "");
      formData.append("unit_id", authDetails?.unit_id || "");
    }

    // Dispatch API call
    dispatch(applyLeaveOrPermissionOrOnduty(tabName, formData));
  };

  const handleTabChange = (tab) => {
    setActiveTab(tab);
    setLocalWeekOfDates({ holidays: [], weekOffs: [] });

    // Optionally, reset the current tab's Formik if needed
    if (tab === "Leave") leaveFormikRef.current?.resetForm();
    if (tab === "Permission") permissionFormikRef.current?.resetForm();
    if (tab === "Onduty") odFormikRef.current?.resetForm();
  };

  return (
      <Container fluid>        
          <Card style={{minHeight:"400px"}}>

          {/* Tabs */}
          <Nav tabs>
            <NavItem>
              <NavLink
                className={classnames({ active: activeTab === "Leave" })}
                onClick={() => handleTabChange("Leave")}
              >
                Leave
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                className={classnames({ active: activeTab === "Permission" })}
                onClick={() => handleTabChange("Permission")}
              >
                Permission
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                className={classnames({ active: activeTab === "Onduty" })}
                onClick={() => handleTabChange("Onduty")}
              >
                On Duty
              </NavLink>
            </NavItem>
          </Nav>

        
          <CardBody>
            <TabContent activeTab={activeTab}>

              {/* Leave Form */}
              <TabPane tabId="Leave">
                  {(localWeekOfDates.holidays?.length > 0 || localWeekOfDates.weekOffs?.length > 0) && (
                    <div
                      className={`alert mt-2 ${
                        holidays?.length > 0 && weekOffs?.length > 0
                          ? "alert-warning" // both present
                          : holidays?.length > 0
                          ? "alert-danger" // only holidays
                          : "alert-success" // only week offs
                      }`}
                    >
                      Your leave range has{" "}
                      {localWeekOfDates.holidays?.length > 0 && (
                        <span className="fw-bold text-danger">
                          Holidays ({localWeekOfDates.holidays.join(", ")})
                        </span>
                      )}{" "}
                      {localWeekOfDates.weekOffs?.length > 0 && (
                        <span className="fw-bold text-success">
                          Week-Offs ({localWeekOfDates.weekOffs.join(", ")})
                        </span>
                      )}
                    </div>
                  )}
                <Formik
                  innerRef={leaveFormikRef}
                  // initialValues={{ employee: "", leaveType: "", fromDate: "", toDate: "", reason: "", halfDay: false, holidayDate: "", session: "", noOfDays: 0,attachment:null }}
                  initialValues={initialLeaveValues}
                  validationSchema={leaveValidationSchema}
                  // onSubmit={handleSubmit}
                  onSubmit={(values) => handleSubmit("Leave", values)}
                >
                  {({ values, setFieldValue, handleBlur,touched,errors }) => (
                    <Form>
                      <Row>
                        <Col md={3}>
                          <FormGroup>
                            <Label>
                              Leave Type <span className="text-danger">*</span>
                            </Label>
                            <CustomSelect
                                id="leaveType"
                                name="leaveType"
                                // options={leaveTypeOptions.map(opt => ({
                                //   value: opt.value,
                                //   label: opt.label,
                                // }))}
                                // value={
                                //   leaveTypeOptions
                                //     .filter(opt => opt.value === values.leaveType)
                                //     .map(opt => ({
                                //       value: opt.value,
                                //       label: opt.label,
                                //     }))[0] || null
                                // }
                                options={employeeLeaveTypeOptions}
                                value={
                                  employeeLeaveTypeOptions.find(
                                    opt => opt.value === values.leaveType
                                  ) || null
                                }
                                onChange={async (val) => {
                                  setFieldValue("leaveType", val ? val.value : "");

                                  if (val) {
                                    const formData = new FormData();
                                    formData.append("emp_id", authDetails?.empid);
                                    formData.append("leave_type", val.value || 0);
                                    formData.append("unit_id", authDetails?.unit_id);

                                    dispatch(fetchLeaveBalance(formData));
                                  }

                                  if (val && values.fromDate && values.toDate) {
                                    const weekForm = new FormData();
                                    weekForm.append("emp_id", authDetails?.empid);
                                    weekForm.append("leave_type", val.value);
                                    weekForm.append("from_date", values.fromDate);
                                    weekForm.append("to_date", values.toDate);

                                    dispatch(fetchWeekOfDates(weekForm));
                                  }
                                }}
                                onBlur={handleBlur}
                                className={touched.leaveType && errors.leaveType ? "is-invalid" : ""}
                              />
                            <ErrorMessage
                              name="leaveType"
                              component="div"
                              className="text-danger"
                            />
                          </FormGroup>
                        </Col>
                        <Col md={3} className="d-flex align-items-center mob-pl">
                          <FormGroup check className="mb-2">
                            <Label check className="d-flex align-items-center">
                              <Field
                                type="checkbox"
                                name="halfDay"
                                className="me-2"
                                onChange={(e) => {
                                  setFieldValue("halfDay", e.target.checked);
                                  if (!e.target.checked) {
                                    setFieldValue("holidayDate", "");
                                    setFieldValue("fromDate", "");
                                    setFieldValue("toDate", "");
                                    setFieldValue("noOfDays", 0);
                                  }
                                }}
                              />
                              Half Day
                            </Label>
                          </FormGroup>
                        </Col>
                        {values.halfDay && (
                        <Col md={3}>
                          <FormGroup>
                            <Label>Halfday Date <span className="text-danger">*</span></Label>
                            <CustomDatePicker
                              name="holidayDate"
                              value={values.holidayDate}
                              onChange={(date) => {
                                setFieldValue("holidayDate", date);
                                setFieldValue("fromDate", date);
                                setFieldValue("toDate", date);
                                setFieldValue("noOfDays", 0.5);
                              }}
                              onBlur={handleBlur}
                            />
                            <ErrorMessage name="holidayDate" component="div" className="text-danger" />
                          </FormGroup>
                        </Col>
                        )}
                        {values.halfDay && (
                           <Col md={3}>
                              <FormGroup>
                                <Label>
                                  Session <span className="text-danger">*</span>
                                </Label>
                                <CustomSelect
                                  id="session"
                                  name="session"
                                  options={sessionOptions.map(opt => ({
                                    value: opt.value,
                                    label: opt.label,
                                  }))}
                                  value={
                                    sessionOptions
                                      .filter(opt => opt.value === values.session)
                                      .map(opt => ({
                                        value: opt.value,
                                        label: opt.label,
                                      }))[0] || null
                                  }
                                  onChange={val =>
                                    setFieldValue("session", val ? val.value : "")
                                  }
                                  onBlur={handleBlur}
                                  className={
                                    touched.session && errors.session ? "is-invalid" : ""
                                  }
                                />
                                <ErrorMessage
                                  name="session"
                                  component="div"
                                  className="text-danger"
                                />
                              </FormGroup>
                            </Col>
                        )}
                        <Col md={3}>
                          <FormGroup>
                            <Label>
                              From Date <span className="text-danger">*</span>
                            </Label>
                            <CustomDatePicker
                              name="fromDate"
                              value={values.fromDate}
                              onChange={(date) => {
                                setFieldValue("fromDate", date);

                                // calculate days
                                if (values.toDate) {
                                  const diff = Math.max(
                                    0,
                                    (new Date(values.toDate) - new Date(date)) / (1000 * 60 * 60 * 24) + 1
                                  );
                                  setFieldValue("noOfDays", diff);
                                }

                                // call API if both dates exist
                                if (date && values.toDate && authDetails?.empid) {
                                  const formData = new FormData();
                                  formData.append("emp_id", authDetails?.empid);
                                  formData.append("from_date", date);
                                  formData.append("to_date", values.toDate);

                                  dispatch(checkLeaveExists(formData));
                                }

                                if (values.leaveType && date && values.toDate) {
                                  const weekForm = new FormData();
                                  weekForm.append("emp_id", authDetails?.empid);
                                  weekForm.append("leave_type", values.leaveType);
                                  weekForm.append("from_date", date);
                                  weekForm.append("to_date", values.toDate);

                                  dispatch(fetchWeekOfDates(weekForm));
                                }
                              }}
                              onBlur={handleBlur}
                              disabled={values.halfDay}
                            />
                            <ErrorMessage name="fromDate" component="div" className="text-danger" />
                          </FormGroup>
                        </Col>

                        <Col md={3}>
                          <FormGroup>
                            <Label>
                              To Date <span className="text-danger">*</span>
                            </Label>
                            <CustomDatePicker
                              name="toDate"
                              value={values.toDate}
                              onChange={(date) => {
                                setFieldValue("toDate", date);

                                // calculate days
                                if (values.fromDate) {
                                  const diff = Math.max(
                                    0,
                                    (new Date(date) - new Date(values.fromDate)) / (1000 * 60 * 60 * 24) + 1
                                  );
                                  setFieldValue("noOfDays", diff);
                                }

                                // call API if both dates exist
                                if (values.fromDate && date && authDetails?.empid) {
                                  const formData = new FormData();
                                  formData.append("emp_id", authDetails?.empid);
                                  formData.append("from_date", values.fromDate);
                                  formData.append("to_date", date);

                                  dispatch(checkLeaveExists(formData));
                                }

                                if (values.leaveType && values.fromDate && date) {
                                  const weekForm = new FormData();
                                  weekForm.append("emp_id", authDetails?.empid);
                                  weekForm.append("leave_type", values.leaveType);
                                  weekForm.append("from_date", values.fromDate);
                                  weekForm.append("to_date", date);

                                  dispatch(fetchWeekOfDates(weekForm));
                                }
                              }}
                              onBlur={handleBlur}
                              disabled={values.halfDay}
                            />
                            <ErrorMessage name="toDate" component="div" className="text-danger" />
                          </FormGroup>
                        </Col>
                        
                        <Col md={3}>
                        <FormGroup>
                            <Label>Number of Days</Label>
                            <Input type="text" name="noOfDays" value={values.noOfDays} disabled className="form-control" />
                            <ErrorMessage name="noOfDays" component="div" className="text-danger" />
                          </FormGroup>
                        </Col>
                        <Col md={3}>
                            <FormGroup>
                              <Label>Attachment</Label>
                              <Input
                                type="file"
                                name="attachment"
                                onChange={(event) => setFieldValue("attachment", event.currentTarget.files[0])}
                                className="form-control"
                              />
                              <ErrorMessage name="attachment" component="div" className="text-danger" />
                            </FormGroup>
                        </Col>
                        {values.leaveType && employeeLeaveTypeOptions.some(lt => String(lt.value) === String(values.leaveType) && lt.eligible_leave === 0) && (
                        <>
                          <Col md={3}>
                            <FormGroup>
                              <Label>Eligible Leave</Label>
                              <div>{leaveBalance[0]?.total_leave ?? "--"}</div>
                            </FormGroup>
                          </Col>
                          <Col md={3}>
                            <FormGroup>
                              <Label>Balance Leave</Label>
                              <div>{leaveBalance[0]?.balance_leave ?? "--"}</div>
                            </FormGroup>
                          </Col>
                        </>
                      )}
                         {/* {(leaveTypeOptions.find(l => String(l.value) === String(values.leaveType))?.eligible_leave === 1) && (
                          <>
                            <Col md={3}>
                              <FormGroup>
                                <Label>Eligible Leave</Label>
                                <div>{leaveBalance[0]?.total_leave}</div>
                              </FormGroup>
                            </Col>
                            <Col md={3}>
                              <FormGroup>
                                <Label>Balance Leave</Label>
                                <div>{leaveBalance[0]?.balance_leave}</div>
                              </FormGroup>
                            </Col>
                          </>
                        )}                    */}
                        
                        <Col md={6}>
                          <FormGroup>
                            <Label>Reasons <span className="text-danger">*</span></Label>
                            <Field as="textarea" name="reason" className="form-control" />
                            <ErrorMessage name="reason" component="div" className="text-danger" />
                          </FormGroup>      
                        </Col>
                        <Col className="d-flex align-items-end justify-content-end mob-center">
                            <Button type="submit" className="btn button-save">
                              <i className="fas fa-save me-1" />Apply
                            </Button></Col>
                      </Row>
                    </Form>
                  )}
                </Formik>                
              </TabPane>

              {/* Permission Form */}
              <TabPane tabId="Permission">
                <Formik
                  innerRef={permissionFormikRef}
                  initialValues={{
                    employee: authDetails?.empid,
                    fromDate: "",
                    fromTime: "",
                    toTime: "",
                    reason: "",
                  }}
                  validationSchema={permissionValidationSchema}
                  // onSubmit={handleSubmit}
                  onSubmit={(values) => handleSubmit("Permission", values)}
                >
                  {({ values, setFieldValue, handleBlur, touched, errors, setFieldTouched }) => (
                    <Form>
                      <Row>
                        {/* Date */}
                        <Col md={3}>
                          <FormGroup>
                            <Label>Date <span className="text-danger">*</span></Label>
                            <CustomDatePicker
                              name="fromDate"
                              value={values.fromDate}
                              onChange={(date) => setFieldValue("fromDate", date)}
                              onBlur={handleBlur}
                            />
                            {touched.fromDate && errors.fromDate && (
                              <div className="text-danger">{errors.fromDate}</div>
                            )}
                          </FormGroup>
                        </Col>

                        {/* From Time */}
                        <Col md={3}>
                          <FormGroup>
                            <Label>From Time <span className="text-danger">*</span></Label>
                            <CustomTimePicker
                              name="fromTime"
                              value={values.fromTime}
                              onChange={(val) => setFieldValue("fromTime", val)}
                              onBlur={() => setFieldTouched("fromTime", true)}
                              placeholder="Select Time"
                              format="hh:mm A"
                            />
                            {touched.fromTime && errors.fromTime && (
                              <div className="text-danger">{errors.fromTime}</div>
                            )}
                          </FormGroup>
                        </Col>

                        {/* To Time */}
                        <Col md={3}>
                          <FormGroup>
                            <Label>To Time <span className="text-danger">*</span></Label>
                            <CustomTimePicker
                              name="toTime"
                              value={values.toTime}
                              onChange={(val) => setFieldValue("toTime", val)}
                              onBlur={() => setFieldTouched("toTime", true)}
                              placeholder="Select Time"
                              format="hh:mm A"
                            />
                            {touched.toTime && errors.toTime && (
                              <div className="text-danger">{errors.toTime}</div>
                            )}
                          </FormGroup>
                        </Col>
                      </Row>

                      <Row>
                        <Col md={6}>
                          <FormGroup>
                            <Label>Reason for Permission <span className="text-danger">*</span></Label>
                            <Field as="textarea" name="reason" className="form-control" />
                            <ErrorMessage name="reason" component="div" className="text-danger" />
                          </FormGroup>
                        </Col>

                        <Col md={3}>
                          <FormGroup>
                            <Label>Available Permission</Label> 
                            <div>
                              {dropdownAutoList.find(emp => emp.value === authDetails?.empid)?.full_day_minutes || "0.00"}
                            </div>                           
                          </FormGroup>
                        </Col>
                        <Col md={3}>
                              <FormGroup>
                                <Label>Availed Permission</Label>
                                <div>
                                  {dropdownAutoList.find(emp => emp.value === authDetails?.empid)?.half_day_minutes || "0.00"}
                                </div> 
                              </FormGroup>                          
                        </Col>

                        <Col className="text-end mob-center">
                          <Button type="submit" className="btn button-save">
                            <i className="fas fa-save me-1" />
                            Apply
                          </Button>
                        </Col>
                      </Row>
                    </Form>
                  )}
                </Formik>
              </TabPane>

              {/* On Duty Form */}
              <TabPane tabId="Onduty">
                  <Formik
                    innerRef={odFormikRef}
                    initialValues={{
                      employee: authDetails?.empid,
                      fromTime: null,
                      toTime: null,
                      reason: "",
                      totalHours: "", 
                      totalMinutes: 0, 
                    }}
                    validationSchema={ondutyValidationSchema}
                    // onSubmit={handleSubmit}
                    onSubmit={(values) => handleSubmit("Onduty", values)}
                  >
                    {({ values, setFieldValue, handleBlur, touched, errors, setFieldTouched }) => (
                      <Form>
                        <Row>
                          {/* From Time */}
                          <Col md={3}>
                            <FormGroup>
                              <Label for="fromTime">
                                From Time <span className="text-danger">*</span>
                              </Label>
                              <CustomDateTimePicker
                                name="fromTime"
                                value={values.fromTime || null}
                                onChange={(val) => {
                                  setFieldValue("fromTime", val);
                                  updateTotalHours(val, values.toTime);
                                }}
                                onBlur={() => setFieldTouched("fromTime", true)}
                                placeholder="Select Time"
                                // disableFuture={true}
                              />
                              {touched.fromTime && errors.fromTime && (
                                <div className="text-danger">{errors.fromTime}</div>
                              )}
                            </FormGroup>
                          </Col>

                          {/* To Time */}
                          <Col md={3}>
                            <FormGroup>
                              <Label for="toTime">
                                To Time <span className="text-danger">*</span>
                              </Label>
                              <CustomDateTimePicker
                                name="toTime"
                                value={values.toTime || null}
                                onChange={(val) => {
                                  setFieldValue("toTime", val);
                                  updateTotalHours(values.fromTime, val);
                                }}
                                onBlur={() => setFieldTouched("toTime", true)}
                                placeholder="Select Time"
                                // disableFuture={true}
                              />
                              {touched.toTime && errors.toTime && (
                                <div className="text-danger">{errors.toTime}</div>
                              )}
                            </FormGroup>
                          </Col>

                          <Col md={3}>
                            <FormGroup>
                              <Label>Total Hours</Label>
                              <div className="form-control-plaintext">
                                {/* {formik.values.totalHours ? `${formik.values.totalHours} hours` : "--"} */}
                                {formik.values.totalHours || "--"}
                              </div>
                            </FormGroup>
                          </Col>                          
                        </Row>
                        <Row>
                          {/* Reason */}
                          <Col md={9}>
                            <FormGroup>
                              <Label>
                                Reason for On Duty <span className="text-danger">*</span>
                              </Label>
                              <Field as="textarea" name="reason" className="form-control" rows="3"/>
                              <ErrorMessage name="reason" component="div" className="text-danger" />
                            </FormGroup>
                          </Col>

                          <Col className="d-flex align-items-end justify-content-end mob-center">
                            <Button type="submit" className="btn button-save">
                              <i className="fas fa-save me-1" /> Apply
                            </Button>
                          </Col>
                        </Row>
                      </Form>
                    )}
                  </Formik>
                </TabPane>

            </TabContent>
          </CardBody>
        </Card>
      </Container >
  );
};

export default LeaveApply;




